// import React from 'react';
// import Checkbox from '@material-ui/core/Checkbox';
// import Component from 'mson/lib/component';
// import FormControlLabel from '@material-ui/core/FormControlLabel';

import attach from "mson-react/lib/attach";
import Reader from "../../lib/reader";

import React from "react";

class ReaderButtonField extends React.PureComponent {
  // classes = useStyles();

  render() {
    const { processor, ready } = this.props;

    return <Reader process={processor} ready={ready} />;
  }
}
const returnValue = attach(["processor", "ready"])(ReaderButtonField);

export default returnValue;
